// import axios from "axios";

// export default axios.create({
//   baseURL: "http://localhost:2222",
// });

import axios from "axios";

export const axiosUrl = axios.create({
  //   baseURL: "http://localhost:2222/api/",
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://kuxtech-pro-server.vercel.app/api/"
      : "http://localhost:2222/api/",
});
